<template>
    <notifications classes="info-notification" position="bottom right" animation-name="v-fade-left" :width="500"/>
</template>

<script>

    export default {
        name: 'info-notification',
    }

</script>